import Vue from 'vue';
import App from './App.vue';
import router from './router';
import store from './store';
import '@/icon';
import '@/utils/permission';
import '@/assets/tailwindcss.css'
import { installPrerenderReady } from '@/utils/prerender-ready'

Vue.config.productionTip = false;

import request from '@/utils/request'

Vue.prototype.$http = function DeptAppSave(url, data) {
  return request({
    url: url,
    method: 'post',
    data
  })
}

Vue.prototype.$isxj = window['pathConfig'][process.env.NODE_ENV].isxunjee

new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app');

// 构建期预渲染：在首屏接口都返回后通知 Puppeteer 可以抓取 HTML 了
// 浏览器里无人监听该事件，无副作用
installPrerenderReady(router);
